import { render, staticRenderFns } from "./DonutChartCluster.vue?vue&type=template&id=a8d890bc&scoped=true&"
import script from "./DonutChartCluster.vue?vue&type=script&lang=js&"
export * from "./DonutChartCluster.vue?vue&type=script&lang=js&"
import style0 from "./DonutChartCluster.vue?vue&type=style&index=0&id=a8d890bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d890bc",
  null
  
)

export default component.exports